import { MdUpload } from "react-icons/md";

export const FileUploadBtn = ({text,isBorder,isDisabled}) => {
    return (
        <button className={`btn btn-theme ${isBorder ? "btn-border bg-transparent" : "btn-white-blue"} ${isDisabled ? "btn-error" : ""} d-flex align-items-center gap-2`} type='button' disabled={isDisabled}>
            <MdUpload size={18} />
            {text}
        </button>
    )
}

